<app-header></app-header>
<router-outlet></router-outlet>

<div class="footer" style="margin-top:10px">
    <app-footer></app-footer>
</div>
